import { makeObservable, autorun, observable } from 'mobx';
import { create, persist } from 'mobx-persist';
import dayjs from '../dayjs';

import i18n from '../i18n';

class UIStore {

  @persist @observable referrer = null;
  @persist @observable language = 'en';
  @observable selectedMenuItem = 'home';
  @observable openMenuSections = [];

  @observable home = {
    endDate: undefined,
    selectedChart: 'day',
    showRangePicker: false,
    startDate: undefined
  };

  @observable charges = {
    filters: { statusCode: { type: '$nin', value: ['410'] } },
    query: { statusCode: { $nin: [410] } },
    page: 0
  };

  @observable customers = {
    filters: { email: { type: '$ne', value: null } },
    query: { email: { $ne: null } },
    page: 0
  };

  @observable balance = {
    filters: {},
    query: {},
    page: 0
  };

  @observable admin = {
    users: {
      filters: {},
      query: {},
      page: 0
    },
    organizations: {
      filters: {},
      query: { $sort: { approvedAt: -1 } },
      page: 0
    },
    addresses: {
      filters: {
        type: { label: 'Address', value: 'address' },
        after: dayjs().subtract(1, 'month'),
        search: undefined,
        amount: undefined,
        filterByAmount: false
      },
      query: {},
      page: 0
    }
  };

  @observable invoices = {
    filters: { archivedAt: { value: false } },
    query: { archivedAt: null },
    page: 0
  };

  constructor () {
    makeObservable(this);
    const hydrate = create();
    hydrate('ui-store', this);
    // dayjs locales are lowercase base codes ('es', 'en') with no automatic
    // region fallback, unlike moment which mapped 'es-ES' → 'es' itself.
    autorun(() => dayjs.locale(this.language.split('-')[0].toLowerCase()));

    i18n.on('languageChanged', language => {
      const baseLanguage = language.split('-')[0];

      switch (baseLanguage) {
        case 'es':
          this.language = 'es-ES';
          break;
        default:
          this.language = 'en-US';
      }
    });
  }

  handleRouteChange = path => {
    const section = path.split('/').pop();
    const sectionPath = section.split('_');
    const parent = sectionPath[0];

    this.selectedMenuItem = section;

    if (sectionPath.length > 1 && parent && !this.openMenuSections.includes(parent)) {
      this.openMenuSections.push(parent);
    }
  };

  resetState = () => {
    this.charges = {
      filters: { statusCode: { type: '$nin', value: ['410'] } },
      query: { statusCode: { $nin: ['410'] } },
      page: 0
    };

    this.customers = {
      filters: { email: { type: '$ne', value: null } },
      query: { email: { $ne: null } },
      page: 0
    };

    this.balance = {
      filters: {},
      query: {},
      page: 0
    };

    this.admin = {
      users: {
        filters: {},
        query: {},
        page: 0
      },
      organizations: {
        filters: {},
        query: { $sort: { approvedAt: -1 } },
        page: 0
      },
      addresses: {
        filters: {
          type: { label: 'Address', value: 'address' },
          after: dayjs().subtract(1, 'month'),
          search: undefined,
          amount: undefined,
          filterByAmount: false
        },
        query: {},
        page: 0
      }
    };

    this.invoices = {
      filters: {},
      query: {},
      page: 0
    };
  };

  updateReferrer = path => {
    this.referrer = path;
  };
}

export default new UIStore();
